import{isObject as r}from"@guildeducationinc/type-guards";var t=function(t){return r(t)&&!("__type"in t)};export{t as isUnbranded};
